import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Page = styled.div`
  max-width: 800px;
  margin: 40px auto;
  padding: 0 20px;
  color: var(--text);
`;

const OrderSuccess = () => {
  useEffect(() => {
    // could clear local cart here if desired
  }, []);
  return (
    <Page>
      <h2 style={{ color: 'var(--accent)' }}>Payment Successful</h2>
      <p>Thanks for your order! We're processing it now.</p>
      <p>
        You can return to the <Link to="/products">Products</Link> or go to the <Link to="/">Home</Link> page.
      </p>
    </Page>
  );
};

export default OrderSuccess;
